import { AdaStatLink } from "@/components/adastat-link";
import { AssetLabel } from "@/components/asset-label";
import { type Column, DataList } from "@/components/data-list";
import type { PoolInfo } from "@/generated/api/model";
import { utxoRef } from "@/lib/utxo-ref";

// Each side of the pair opens its own asset card; `data-field` keeps the pair readable as one value.
function Pair({ pool }: { pool: PoolInfo }) {
    return (
        <span data-field="Pair" className="whitespace-nowrap">
            <AssetLabel {...pool.asset_a} />/<AssetLabel {...pool.asset_b} />
        </span>
    );
}

const COLUMNS: Column<PoolInfo>[] = [
    { label: "Pair", render: (pool) => <Pair pool={pool} />, className: "font-semibold", title: true },
    { label: "DEX", value: (pool) => pool.dex_name, title: true },
    { label: "Reserve A", value: (pool) => pool.reserve_a, className: "tabular-nums" },
    { label: "Reserve B", value: (pool) => pool.reserve_b, className: "tabular-nums" },
    { label: "Price", value: (pool) => pool.price, className: "tabular-nums" },
    { label: "TVL", value: (pool) => pool.tvl, className: "tabular-nums" },
    { label: "Buy 100", value: (pool) => pool.calculate_buy_100, className: "tabular-nums" },
    { label: "Sell 100", value: (pool) => pool.calculate_sell_100, className: "tabular-nums" },
    { label: "Buy fee", value: (pool) => pool.buy_fee },
    { label: "Sell fee", value: (pool) => pool.sell_fee },
    {
        label: "Pool UTXO",
        render: (pool) => (
            <AdaStatLink
                kind="utxo"
                value={utxoRef(pool.transaction_id, pool.output_index)}
                label="Pool UTXO"
                fit="table"
            />
        ),
        wide: true,
    },
];

export function PoolTable({ pools, label }: { pools: PoolInfo[]; label: string }) {
    return (
        <DataList
            rows={pools}
            columns={COLUMNS}
            rowKey={(pool) => utxoRef(pool.transaction_id, pool.output_index)}
            label={label}
        />
    );
}
